import styled from "styled-components";
import { CustomModal } from "components/custom-modal";
import { responsive } from "theme/reponsive";

export const FinancialWrapper = styled.div`
   display: flex;
   width: 100%;
   justify-content: space-between;
   align-items: center;
`;

export const FinancialTableWrapper = styled.div`
   margin-top: 50px;
`;

export const NotificationWrapper = styled.div`
   margin: 80px auto;
   width: 790px;

   .content-div {
      width: 790px;
      background-color: #fff;
      border-radius: 10px;
      padding: 40px 24px 80px 40px;
   }
`;

export const DetailsWrapper = styled.div`
   margin: 50px auto;
   width: 600px;
   background-color: #fff;
   border-radius: 10px;
   padding: 20px 30px 60px;
   div.details {
      display: flex;
      align-items: center;
      .data {
         margin-left: 10px;
      }

      .doc-name {
         margin-left: 19px;
      }

      .download {
         margin-left: 30px;
         span {
            color: ${({ theme }) => theme.colors?.primary};
            font-weight: 500;
            cursor: pointer;
         }
      }
   }

   .btns-div {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      width: 220px;
   }
`;

export const FinancialTabDiv = styled.div`
   display: flex;
   align-items: center;
   margin-top: 100px;

   .tab {
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      color: #999999;
      padding-bottom: 10px;
      width: 158px;
      border: none;
      outline: none;
      background-color: transparent;
      text-align: start;
      border-bottom: 3px solid transparent;
      cursor: pointer;
   }
   .active {
      color: ${({ theme }) => theme.colors?.primary};
      font-weight: 500;
      border-bottom: 3px solid #3578e5;
   }
`;

export const FinancialFormHeader = styled.div`
   margin-top: 50px;

   .desc {
      margin-top: 30px;
      line-height: 23px;
      color: #666666;

      span {
         a {
            text-decoration: none;
            color: ${({ theme }) => theme.colors?.primary};
         }
      }
   }
`;

export const ModalWrapper = styled.div`
   height: 460px;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   .title {
      font-size: 22px;
      line-height: 28px;
      text-align: center;
      color: #000000;
      font-weight: 700;
      width: 379px;
   }

   .desc {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #666666;
      margin-top: 30px;
      width: 323px;
      span {
         a {
            text-decoration: none;
            color: ${({ theme }) => theme.colors?.primary};
         }
      }
   }
`;

export const DashboardModal = styled(CustomModal)`
   height: 100%;
`;

export const ParentAccountFinancialWrapper = styled.div`
   margin: 50px 0 30px;
   padding: 50px 16px 0 17px;
`;

export const CardsGridDiv = styled.div`
   margin-top: 19px;
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 2rem;

   ${responsive("$medium")`
   grid-template-columns: repeat(2, 1fr);
   margin: 0 1.5rem;
   `}

   ${responsive("$small")`
   grid-template-columns: repeat(1, 1fr);
   margin: 0 0.5rem;
   `}
`;

export const ApplicationCardsGridDiv = styled.div`
   margin-top: 19px;
   display: grid;
   grid-template-columns: repeat(2, 407px);
   gap: 2rem;

   ${responsive("$medium")`
   grid-template-columns: repeat(2, 1fr);
   margin: 0 1.5rem;
   `}

   ${responsive("$small")`
   grid-template-columns: repeat(1, 1fr);
   margin: 0 0.5rem;
   `}
`;

export const UserFinanceCard = styled.div`
   width: 364px;
   height: 210px;

   @media screen and (max-width: 767px) {
      width: 100%;
   }

   .userFinanceFlex {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 21px 43px 21px 24px;
      background-color: #fff;
      border-radius: 5px;
      height: 210px;

      .userFinanceLogo {
         height: 50px;
         width: auto;
         max-width: 130px;
         object-fit: cover;
      }

      .userFinanceTitle {
         font-weight: 700;
         font-size: 14px;
         line-height: 18px;
         color: #676464;
         margin: 6px 0 9px;
      }

      .userFinanceDescription {
         font-size: 12px;
         line-height: 18px;
         color: #a8a8a8;
         display: -webkit-box;
         -webkit-line-clamp: 3;
         -webkit-box-orient: vertical;
         overflow: hidden;
         text-overflow: ellipsis;
         height: fit-content;
         white-space: normal;
      }
   }
`;

export const SingleFinanceDetailsWrapper = styled.div`
   background: #fff;
   padding: 48px 79px 132px 47px;

   ${responsive("$medium")`
      padding: 20px 10px;
   `}

   .flex-title {
      display: flex;
      align-items: center;

      .flex-title_image {
         width: 88px;
         height: 88px;
         object-fit: cover;
         margin-right: 30px;
      }

      .flex-title_header {
         font-weight: 700;
         font-size: 25px;
         line-height: 32px;
         color: #444444;
      }

      ${responsive("$medium")`
      .flex-title_image {
         width: 66px;
         height: 66px;
      }

       .flex-title_header {
         font-size: 20px;
          font-weight: 700;
      }
   `}

      ${responsive("$small")`
      .flex-title_image {
         width: 44px;
         height: 44px;
      }

       .flex-title_header {
         font-size: 18px;
         line-height: 40px;
          font-weight: 700;
      }
   `}
   }

   .single-loan-description {
      margin-top: 31px;
      font-size: 16px;
      line-height: 24px;

      color: #a8a8a8;
   }

   .loan-button-div {
      margin-top: 35px;
      width: 236px;
   }
`;

export const UserApplicationFinanceCard = styled.div`
   width: 407px;
   height: 240px;

   @media screen and (max-width: 767px) {
      width: 100%;
   }

   .userFinanceApplicationFlex {
      display: flex;
      padding: 31px 40px 35px 22px;
      background-color: #fff;
      border-radius: 5px;
      height: 240px;

      .userFinanceLogo {
         height: 54px;
         width: 54px;
         background: #cccccc;
         border-radius: 100%;
         margin-right: 12px;

         img {
            width: 100%;
            height: 100%;
            border-radius: 100%;
            object-fit: cover;
         }
      }

      .userFinanceApplicationTitle {
         font-weight: 500;
         font-size: 16px;
         line-height: 20px;
         color: #444444;
         margin-bottom: 10px;
      }

      .userFinanceApplicationDescription {
         font-size: 16px;
         line-height: 20px;
         text-transform: uppercase;
         color: #9d9595;
         display: -webkit-box;
         -webkit-line-clamp: 2;
         -webkit-box-orient: vertical;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: normal;
      }

      .userFinanceApplicationSummary {
         font-weight: 300;
         font-size: 14px;
         line-height: 18px;
         color: #9d9595;
         margin: 9px 0 10px;
         display: -webkit-box;
         -webkit-line-clamp: 2;
         -webkit-box-orient: vertical;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: normal;
      }

      .userFinanceDate {
         font-size: 14px;
         line-height: 18px;
         color: #9d9595;
         margin-bottom: 10px;
      }

      .userFinanceStatus {
         font-size: 14px;
         line-height: 18px;
         color: #444444;

         span {
            text-transform: capitalize;
            margin-left: 8px;
         }
      }
   }
`;

export const LoanTitle = styled.h1`
   color: #091b66;
   font-size: 24px;
   font-weight: 700;
   margin-bottom: 100px;
`;
